// extracted by mini-css-extract-plugin
export default {"switch":"switchInput_switch__MFQdU","checked":"switchInput_checked__mpOWv","text":"switchInput_text__scYDj"};